let map = null;
const url = document.getElementById('getBranchesRoute').value;

// Wait for DOM to be fully loaded
document.addEventListener('DOMContentLoaded', function () {
   // Load all available stores
   getAllStores();

   // Store search
   document.getElementById('searchMapForm').addEventListener('submit', (e) => {
      e.preventDefault();
      getSearchCards();
   });
});

function getAllStores() {
   let latitude = 0;
   let longitude = 0;
   fetch(url, {
      method: 'POST',
      headers: {
         "Content-Type": "application/json",
         'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ latitude: latitude, longitude: longitude }),
   })
      .then(response => response.text())
      .then(postsHtml => {
         updateCardsAndMap(postsHtml);
      })
      .catch(error => console.error('Error:', error));
}

function getSearchCards() {
   let search = document.getElementById('search').value.toLowerCase();
   fetch(url, {
      method: 'POST',
      headers: {
         "Content-Type": "application/json",
         'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ search: search }),
   })
      .then(response => response.text())
      .then(postsHtml => {
         if (!postsHtml || !postsHtml.trim()) {
            alert('Nenhuma Loja encontrada com a pesquisa realizada.');
         } else {
            updateCardsAndMap(postsHtml, true);
         }
      })
      .catch(error => console.error('Error:', error));
}

function updateCardsAndMap(stores, isSearch = false) {
   const cardsContainer = document.getElementById('map-cards');
   cardsContainer.innerHTML = stores;
   initSwiperAndCards()

   //  // Add map button click handler
   //    const mapBtn = card.querySelector('#btn-ir-ao-site');
   //    mapBtn.addEventListener('click', () => {
   //       // Remove active class from all cards
   //       document.querySelectorAll('.item').forEach(item => item.classList.remove('active'));
   //       // Add active class to clicked card
   //       cardElement.querySelector('.item').classList.add('active');
   //       // Center map on store location and open popup
   //       if (map) {
   //             map.setView([store.lat, store.lng], 16);
   //             // Find and open the corresponding marker
   //             const markers = document.querySelectorAll('.leaflet-marker-icon');
   //             markers.forEach(marker => {
   //                const markerInstance = marker.__marker;
   //                if (markerInstance && markerInstance.getLatLng().lat === parseFloat(store.lat) && markerInstance.getLatLng().lng === parseFloat(store.lng)) {
   //                   markerInstance.openPopup();
   //                }
   //             });
   //       }
   //    });

   // Default center coordinates (São Paulo)
   let defaultLatitude = '-23.547503153109968';
   let defaultLongitude = '-46.57708272680397';

   // Wait a bit for the DOM to update before generating the map
   setTimeout(() => {
      generateMap(isSearch);
      map.setView([defaultLatitude, defaultLongitude], 5);
   }, 100);
}

function generateMap(isSearch = false) {
   const mapElement = document.getElementById('mapa');
   if (!mapElement) {
      console.error('Map element not found');
      return;
   }

   if (isSearch && map) {
      map.remove();
      mapElement.innerHTML = "";
   }

   let iconWidthAndHeight = [
      screen.width > 992 ? 34 : 34,
      screen.width > 992 ? 51 : 51,
   ];

   const mapIcon = document.querySelector("#map-icon");
   if (!mapIcon) {
      console.error('Map icon not found');
      return;
   }

   let customIcon = {
      iconUrl: mapIcon.value,
      iconSize: [iconWidthAndHeight[0], iconWidthAndHeight[1]],
      iconAnchor: [iconWidthAndHeight[0] / 2, iconWidthAndHeight[1]], // Center bottom of icon
      popupAnchor: [0, -iconWidthAndHeight[1] - 10], // Position popup above the marker with some padding
      setZIndex: 10,
   }
   let myIcon = L.icon(customIcon);

   const cards = document.querySelectorAll('[mapCard]');

   // If we have cards, use the first one's coordinates
   if (cards.length > 0) {
      const firstCard = cards[0];
      if (firstCard) {
         defaultLatitude = firstCard.getAttribute('data-lat');
         defaultLongitude = firstCard.getAttribute('data-lng');
      }
   }

   // Create map centered on first card or default location
   map = L.map('mapa', {
      closePopupOnClick: true,
      maxZoom: 15
   }).setView([defaultLatitude, defaultLongitude], 14);

   // Desabilitar o scroll do mouse
   map.scrollWheelZoom.disable();

   // Add tile layer
   let layer = new L.TileLayer(
      "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 15
   }
);

   map.addLayer(layer);

   // Add markers for each store
   if (cards.length > 0) {
      cards.forEach((card) => {
         let latitude = card.getAttribute('data-lat');
         let longitude = card.getAttribute('data-lng');
         let title = card.getAttribute('data-title');
         let address = card.getAttribute('data-address');

         let iconOptions = {
            title: title,
            draggable: false,
            icon: myIcon,
         }

         // Create marker
         let marker = new L.Marker([latitude, longitude], iconOptions);
         marker.addTo(map);

         // Store marker instance on DOM element for later reference
         marker._icon.__marker = marker;

         // Bind popup
         marker.bindPopup(
            `
               <h4>${title}</h4>
               <ul>
                  <li>
                        <a href="https://www.google.com/maps?q=${encodeURIComponent(address)}" target="_blank">
                           ${address}
                        </a>
                  </li>
               </ul>
            `, {
            autoClose: true,
            closeButton: false,
            closeOnClick: false,
            offset: [185, -160], // Adjust popup position relative to marker
            className: 'custom-popup' // Add custom class for styling if needed
         });

         // Open popup for first marker
         if (defaultLatitude === latitude) {
            marker.openPopup();
         }
      });
   }

   setTimeout(() => {
      if (map) {
         map.setZoom(5);
      }
   }, 300);
}

function initSwiperAndCards() {
   // Destroi o swiper antigo, se existir
   if (window.swiperMap) {
      window.swiperMap.destroy(true, true);
   }

   // Cria o novo swiper
   window.swiperMap = new Swiper('.swiper-map', {
      slidesPerView: 'auto',
      direction: 'vertical',
      spaceBetween: 24,
      autoHeight: true,

      navigation: {
         prevEl: '.map .button-prev',
         nextEl: '.map .button-next',
      },
      breakpoints: {
         320: {
            direction: 'horizontal',
            slidesPerView: 1.5,
            spaceBetween: 16,
            centeredSlides: true,
         },
         1024: {
            direction: 'vertical',
            slidesPerView: 'auto',
         }
      }
   });

   // Adiciona eventos de click nos cards
   let cards = document.querySelectorAll('.swiper-map .card');

   cards.forEach(card => {
      let parent = card.parentElement;
      let latitude = parent.getAttribute('data-lat');
      let longitude = parent.getAttribute('data-lng');

      card.addEventListener('click', function() {
         zoomTo(latitude, longitude);

  // First, hide content of all cards that will change and add loading state
         cards.forEach(c => {
            let small = c.querySelector('.content-sm');
            let large = c.querySelector('.content-lg');

            // Hide content of currently active card (will become inactive)
            if (c.classList.contains('active')) {
               small.classList.add('d-none');
               large.classList.add('d-none');
               c.classList.add('loading');
            }

            // Hide content of clicked card (will become active)
            if (c === this) {
               small.classList.add('d-none');
               large.classList.add('d-none');
               c.classList.add('loading');
            }
         });

         // Wait for opacity transition, then change active state and width
         setTimeout(() => {
            // reset active states
            cards.forEach(c => {
               c.classList.remove('active');
            });

            // Add active to clicked card (this triggers width transition)
            this.classList.add('active');

            // Wait for width transition to complete, then show appropriate content
            setTimeout(() => {
               cards.forEach(c => {
                  let small = c.querySelector('.content-sm');
                  let large = c.querySelector('.content-lg');

                  // Remove loading state
                  c.classList.remove('loading');

                  if (c.classList.contains('active')) {
                     small.classList.add('d-none');
                     large.classList.remove('d-none');
                  } else {
                     small.classList.remove('d-none');
                     large.classList.add('d-none');
                  }
               });
            }, 300); // Match the transition duration
         }, 300); // Match the transition duration
      });
   });

}

function zoomTo(lat, lng, zoom = 15) {
   if (map) {
      map.setView([lat, lng], zoom);
   }
}

// Chame initSwiperAndCards() sempre após atualizar os cards via AJAX!
